import { useCallback, useState } from "react";
import { useSearchParams } from "react-router-dom";

export const PARTNER_REFERRAL_URL_PARAM = "partner";

export const resolvePartnerReferralRowFields = (row) => ({
  partnerId:
    row?.partnerReferralLevel1PartnerId ??
    row?.PartnerReferralLevel1PartnerId ??
    null,
  displayName: (
    row?.partnerReferralDisplayName ??
    row?.PartnerReferralDisplayName ??
    ""
  ).trim(),
});

export const matchesPartnerReferralFilter = (row, filterValue) => {
  if (!filterValue) return true;

  const { partnerId, displayName } = resolvePartnerReferralRowFields(row);
  if (String(partnerId) === String(filterValue)) return true;
  return displayName === filterValue;
};

export const buildPartnerReferralFilterOptionsFromRows = (rows = []) => {
  const map = new Map();

  for (const row of rows) {
    const { partnerId, displayName } = resolvePartnerReferralRowFields(row);
    if (!displayName) continue;

    const value = partnerId != null ? String(partnerId) : displayName;
    if (!map.has(value)) {
      map.set(value, displayName);
    }
  }

  return [...map.entries()]
    .map(([value, label]) => ({ value, label }))
    .sort((a, b) => a.label.localeCompare(b.label, "fa"));
};

export const mergePartnerReferralFilterOptions = (apiOptions = [], rowOptions = []) => {
  const map = new Map();

  for (const option of apiOptions) {
    const partnerId = option?.partnerId ?? option?.PartnerId;
    const displayName = (
      option?.displayName ??
      option?.DisplayName ??
      ""
    ).trim();
    if (!displayName || partnerId == null) continue;
    map.set(String(partnerId), displayName);
  }

  for (const option of rowOptions) {
    if (!option?.value || !option?.label) continue;
    map.set(String(option.value), option.label);
  }

  return [...map.entries()]
    .map(([value, label]) => ({ value, label }))
    .sort((a, b) => a.label.localeCompare(b.label, "fa"));
};

export const usePartnerReferralFilter = (hubMode = false) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [localFilter, setLocalFilter] = useState("");

  const value = hubMode
    ? searchParams.get(PARTNER_REFERRAL_URL_PARAM) || ""
    : localFilter;

  const setValue = useCallback(
    (next) => {
      if (hubMode) {
        setSearchParams(
          (prev) => {
            const params = new URLSearchParams(prev);
            if (next) {
              params.set(PARTNER_REFERRAL_URL_PARAM, next);
            } else {
              params.delete(PARTNER_REFERRAL_URL_PARAM);
            }
            return params;
          },
          { replace: true }
        );
        return;
      }

      setLocalFilter(next || "");
    },
    [hubMode, setSearchParams]
  );

  return [value, setValue];
};
